import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const TabContainer = styled(Clickable)<{ active?: boolean }>`
  color: ${ifProp('active', Colors.GRAY_DARK_30, Colors.GRAY_DARK_20)};
  cursor: pointer;
  font-size: ${Font.Size.M} !important;
  font-family: ${Font.Family.SANS} !important;
  font-weight: 600;
  flex: 1 1 100%;
  letter-spacing: 0;
  margin: 0 !important;
  padding: ${Spacing.THREE_QUARTERS};
  position: relative;
  text-align: center;
  transition: border-color ${Transition.Time.BASE}, color ${Transition.Time.BASE}, font-weight ${Transition.Time.BASE};

  @media screen and (max-width: ${ScreenWidth.SMALL}) {
    font-size: ${Font.Size.S} !important;
  }

  &:after {
    bottom: -2px;
    left: ${Spacing.HALF};
    right: ${Spacing.HALF};
    content: '';
    width: calc(100% - ${Spacing.SINGLE});
    height: 3px;
    background-color: ${ifProp('active', Colors.RASPBERRY, Colors.GRAY_LITE_10)};
    position: absolute;
    transition: background-color ${Transition.Time.BASE}, height ${Transition.Time.BASE}, bottom ${Transition.Time.BASE};
  }

  &:first-child:after {
    left: 0;
    width: calc(100% - ${Spacing.HALF});
  }

  &:last-child:after {
    right: 0;
    width: calc(100% - ${Spacing.HALF});
  }

  &:hover {
    color: ${ifProp('active', Colors.GRAY_DARK_30, Colors.GRAY_DARK_10)};
    &:after {
      background-color: ${ifProp('active', Colors.RADISH, Colors.GRAY_DARK_10)};
    }
  }

  &:active {
    color: ${Colors.GRAY_DARK_30};
    &:after {
      background-color: ${ifProp('active', Colors.RADISH, Colors.GRAY_DARK_30)};
    }
  }
`;
